<template>
  <v-app>
    <Header v-if="showHeaderFooter" />
    <router-view />
    <Footer v-if="showHeaderFooter" />
  </v-app>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'App',
  components: {
    Header,
    Footer
  },
  computed: {
    showHeaderFooter() {
      // 在登录、注册和详情页面不显示header和footer
      const noHeaderRoutes = ['SignIn', 'SignUp', 'ResetPassword', 'ProductDetail', 'PostDetail']
      return !noHeaderRoutes.includes(this.$route.name)
    }
  }
}
</script>

<style>
@font-face {
  font-family: 'Sansita';
  src: url('@/assets/Sansita/Sansita-Regular.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: 'Sansita';
  src: url('@/assets/Sansita/Sansita-Bold.ttf') format('truetype');
  font-weight: bold;
  font-style: normal;
}
@font-face {
  font-family: 'Sansita';
  src: url('@/assets/Sansita/Sansita-Italic.ttf') format('truetype');
  font-weight: normal;
  font-style: italic;
}
@font-face {
  font-family: 'Sansita';
  src: url('@/assets/Sansita/Sansita-ExtraBold.ttf') format('truetype');
  font-weight: 800;
  font-style: normal;
}
@font-face {
  font-family: 'Poppins';
  src: url('@/assets/Poppins/Poppins-Regular.otf') format('opentype');
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: 'Poppins';
  src: url('@/assets/Poppins/Poppins-Bold.otf') format('opentype');
  font-weight: bold;
  font-style: normal;
}
@font-face {
  font-family: 'Poppins';
  src: url('@/assets/Poppins/Poppins-Italic.otf') format('opentype');
  font-weight: normal;
  font-style: italic;
}
body {
  background: #f8f8f8;
  font-family: 'Poppins', Arial, sans-serif;
}
/* 防止移动端出现横向滚动 */
html, body, #app {
  max-width: 100%;
  overflow-x: hidden;
}
/* 统一盒模型，避免 padding 造成溢出 */
*, *::before, *::after {
  box-sizing: border-box;
}
/* 图片不超过容器宽度 */
img {
  max-width: 100%;
  height: auto;
  display: inline-block;
}
</style>
